import AccountResp from "@/interface/api/AccountResp";
import rest from "@/rest/restAccess";
import { reactive } from 'vue'
import nortification, {NORTIFICATION_NOT_LOGIN} from "@/state/NortificationState";

class AccountState {
    public info = {} as AccountResp;
    public isLoaded = false//アカウントを読込んだか。アカウント読込む前のログアウト状態とアカウント読込み後のログアウト状態を識別する用

    public get isLogin() {
        return !!this.info.userName;
    }

    public clear() {
        this.info = {} as AccountResp;
        this.isLoaded = true//アカウントなしとして読込んだ状態とする
        this.emitLoginChanged()
    }

    public reload() {
        return rest.getAccount().then((info) => {
            this.info = info;
            this.isLoaded = true
            nortification.clear(NORTIFICATION_NOT_LOGIN)
            this.emitLoginChanged()
        });
    }

    
    
    //ログイン通知用。watchでログイン検知する場合、動作しないことがあるのでコールバックで通知する
    private callback = [] as Function[]
    public addLoginListener(f:Function){
        this.callback.push(f)
    }
    public removeLoginListener(f:Function){
        this.callback = this.callback.filter(func => func !== f)
    }
    private emitLoginChanged(){
        this.callback.forEach(f => f())
    }
}

//複数のvueで変数の値を共有したいので、事前にnewしたものを渡す。値変更を即HTMLに反映させたいのでリアクティブ化を行っている
export default reactive(new AccountState);
